import { forwardRef } from "react";

import { useFormikContext } from "formik";
import { equals } from "ramda";

import { Button, ButtonProps } from "src/components/Button";

export interface FormikButtonProps extends ButtonProps {
  /** Override the auto-computed disabled state. */
  disabled?: boolean;
}

const FormikButton = forwardRef<HTMLButtonElement, FormikButtonProps>(
  ({ disabled, ...otherProps }, ref) => {
    const { handleSubmit, isSubmitting, values, initialValues, isValid } =
      useFormikContext();

    const isDisabled =
      disabled ?? (isSubmitting || equals(values, initialValues));

    return (
      <Button
        ref={ref}
        disabled={isDisabled}
        loading={isSubmitting && isValid}
        onClick={() => handleSubmit()}
        {...otherProps}
      />
    );
  }
);

FormikButton.displayName = "FormikButton";

export { FormikButton };
